import { render, staticRenderFns } from "./EventView.vue?vue&type=template&id=de1d7ac4&"
import script from "./EventView.ts?vue&type=script&lang=ts&"
export * from "./EventView.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports